import { createFileRoute, Link } from '@tanstack/react-router';
import styled from 'styled-components';
import { AdminFollowUpNetworkMap } from '@/admin/followups/AdminFollowUpNetworkMap';
import { AdminFollowUpNetworkTable } from '@/admin/followups/AdminFollowUpNetworkTable';
import { AdminFollowUpRequestsTable } from '@/admin/followups/AdminFollowUpRequestsTable';
import { AdminFollowUpsTable } from '@/admin/followups/AdminFollowUpsTable';
import { FollowUpsTabs } from '@/admin/followups/FollowUpsTabs';
import { currentTab, validateFollowUpsSearch } from '@/admin/followups/search';
import { useFollowUpsT } from '@/admin/followups/strings';

export const Route = createFileRoute('/admin/follow-ups/')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  validateSearch: validateFollowUpsSearch,
  component: FollowUps,
});

function FollowUps() {
  const t = useFollowUpsT();
  const search = Route.useSearch();
  const tab = currentTab(search);

  return (
    <div>
      <FollowUpsTabs active={tab} />
      {tab === 'follow-ups' && <AdminFollowUpsTable />}
      {tab === 'requests' && <AdminFollowUpRequestsTable />}
      {tab === 'network' && search.view === 'map' && (
        <AdminFollowUpNetworkMap />
      )}
      {tab === 'network' && search.view !== 'map' && (
        <>
          <ViewToggle>
            <Link
              to="/admin/follow-ups/"
              search={(prev) => ({ ...prev, view: 'map' as const })}
              data-testid="follow-ups-view-map"
            >
              {t('admin.followUps.view.map')}
            </Link>
          </ViewToggle>
          <AdminFollowUpNetworkTable />
        </>
      )}
    </div>
  );
}

const ViewToggle = styled.div`
  font-size: 0.875rem;
  margin: 0 var(--component-margin) 0.5rem;
  text-align: right;

  a {
    color: var(--blue);
  }
`;
